import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

export const DisclaimerBox = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 4 }}>
      <Typography variant="caption">{t('blueprints:details.disclaimer')}</Typography>
    </Box>
  );
};
